module.exports = __webpack_public_path__ + "img/featured-techinasia.a1f1837f.png";